import { Grid, Typography } from '@mui/material';
import { MetricCard } from '../ui/MetricCard';
import { FadeIn } from '../ui/FadeIn';
import { Section } from '../ui/Section';
import { Metrics } from '../../lib/social-proof';

interface MetricsSectionProps {
    py?: number;
    metricIds?: string[];
    title?: string;
    intro?: string; // used for "Real people using neumind every day:"
    variant?: 'transparent' | 'default' | 'paper' | 'gradient' | 'dark';
    alignMetrics?: 'left' | 'center' | 'right';
    metricValueColor?: string;
}

export function MetricsSection({
    py = 12,
    metricIds,
    title,
    intro,
    variant = 'transparent',
    alignMetrics = 'left',
    metricValueColor
}: MetricsSectionProps) {

    const displayedMetrics = metricIds
        ? metricIds.map(id => Metrics[id]).filter(Boolean)
        : Object.values(Metrics);

    if (displayedMetrics.length === 0) return null;

    return (
        <Section variant={variant as any} py={py}>
            {title && (
                <FadeIn direction="up">
                    <Typography
                        variant="h3"
                        sx={{
                            mb: intro ? 1 : 6,
                            color: variant === 'dark' ? 'white' : 'text.primary',
                            textAlign: alignMetrics === 'center' ? 'left' : 'inherit' // Keep left unless overridden, but clients page has center alignment on items but left on title? No, clients has left aligned title.
                        }}
                    >
                        {title}
                    </Typography>
                    {intro && (
                        <Typography
                            variant="body1"
                            sx={{
                                mb: 4,
                                color: variant === 'dark' ? 'rgba(255,255,255,0.7)' : 'text.secondary'
                            }}
                        >
                            {intro}
                        </Typography>
                    )}
                </FadeIn>
            )}

            <Grid container spacing={6} justifyContent={alignMetrics === 'center' ? 'center' : 'flex-start'}>
                {displayedMetrics.map((metric, index) => (
                    <Grid item xs={12} md={4} key={metric.id}>
                        <FadeIn delay={index * 150}>
                            <MetricCard
                                tagline={metric.tagline}
                                value={metric.value}
                                label={metric.label}
                                description={metric.description}
                                align={alignMetrics}
                                valueColor={metricValueColor}
                            />
                        </FadeIn>
                    </Grid>
                ))}
            </Grid>
        </Section>
    );
}
